/**
 * @fileoverview gRPC-Web generated client stub for fitness.service.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v2.0.2
// 	protoc              v0.0.0
// source: fitness-service/v1/workout.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')

var fitness$service_v1_client_pb = require('../../fitness-service/v1/client_pb.js')

var fitness$service_v1_exercise_pb = require('../../fitness-service/v1/exercise_pb.js')
const proto = {};
proto.fitness = {};
proto.fitness.service = {};
proto.fitness.service.v1 = require('./workout_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.fitness.service.v1.WorkoutServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.fitness.service.v1.WorkoutServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.CreateWorkoutPlanRequest,
 *   !proto.fitness.service.v1.CreateWorkoutPlanResponse>}
 */
const methodDescriptor_WorkoutService_CreateWorkoutPlan = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.WorkoutService/CreateWorkoutPlan',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.CreateWorkoutPlanRequest,
  proto.fitness.service.v1.CreateWorkoutPlanResponse,
  /**
   * @param {!proto.fitness.service.v1.CreateWorkoutPlanRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.CreateWorkoutPlanResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.CreateWorkoutPlanRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.CreateWorkoutPlanResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.CreateWorkoutPlanResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.WorkoutServiceClient.prototype.createWorkoutPlan =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.WorkoutService/CreateWorkoutPlan',
      request,
      metadata || {},
      methodDescriptor_WorkoutService_CreateWorkoutPlan,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.CreateWorkoutPlanRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.CreateWorkoutPlanResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.WorkoutServicePromiseClient.prototype.createWorkoutPlan =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.WorkoutService/CreateWorkoutPlan',
      request,
      metadata || {},
      methodDescriptor_WorkoutService_CreateWorkoutPlan);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.GetWorkoutPlansRequest,
 *   !proto.fitness.service.v1.GetWorkoutPlansResponse>}
 */
const methodDescriptor_WorkoutService_GetWorkoutPlans = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.WorkoutService/GetWorkoutPlans',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.GetWorkoutPlansRequest,
  proto.fitness.service.v1.GetWorkoutPlansResponse,
  /**
   * @param {!proto.fitness.service.v1.GetWorkoutPlansRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.GetWorkoutPlansResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.GetWorkoutPlansRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.GetWorkoutPlansResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.GetWorkoutPlansResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.WorkoutServiceClient.prototype.getWorkoutPlans =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.WorkoutService/GetWorkoutPlans',
      request,
      metadata || {},
      methodDescriptor_WorkoutService_GetWorkoutPlans,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.GetWorkoutPlansRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.GetWorkoutPlansResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.WorkoutServicePromiseClient.prototype.getWorkoutPlans =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.WorkoutService/GetWorkoutPlans',
      request,
      metadata || {},
      methodDescriptor_WorkoutService_GetWorkoutPlans);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.GetWorkoutPlanRequest,
 *   !proto.fitness.service.v1.GetWorkoutPlanResponse>}
 */
const methodDescriptor_WorkoutService_GetWorkoutPlan = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.WorkoutService/GetWorkoutPlan',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.GetWorkoutPlanRequest,
  proto.fitness.service.v1.GetWorkoutPlanResponse,
  /**
   * @param {!proto.fitness.service.v1.GetWorkoutPlanRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.GetWorkoutPlanResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.GetWorkoutPlanRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.GetWorkoutPlanResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.GetWorkoutPlanResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.WorkoutServiceClient.prototype.getWorkoutPlan =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.WorkoutService/GetWorkoutPlan',
      request,
      metadata || {},
      methodDescriptor_WorkoutService_GetWorkoutPlan,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.GetWorkoutPlanRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.GetWorkoutPlanResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.WorkoutServicePromiseClient.prototype.getWorkoutPlan =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.WorkoutService/GetWorkoutPlan',
      request,
      metadata || {},
      methodDescriptor_WorkoutService_GetWorkoutPlan);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.UpdateWorkoutPlanRequest,
 *   !proto.fitness.service.v1.UpdateWorkoutPlanResponse>}
 */
const methodDescriptor_WorkoutService_UpdateWorkoutPlan = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.WorkoutService/UpdateWorkoutPlan',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.UpdateWorkoutPlanRequest,
  proto.fitness.service.v1.UpdateWorkoutPlanResponse,
  /**
   * @param {!proto.fitness.service.v1.UpdateWorkoutPlanRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.UpdateWorkoutPlanResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.UpdateWorkoutPlanRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.UpdateWorkoutPlanResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.UpdateWorkoutPlanResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.WorkoutServiceClient.prototype.updateWorkoutPlan =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.WorkoutService/UpdateWorkoutPlan',
      request,
      metadata || {},
      methodDescriptor_WorkoutService_UpdateWorkoutPlan,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.UpdateWorkoutPlanRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.UpdateWorkoutPlanResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.WorkoutServicePromiseClient.prototype.updateWorkoutPlan =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.WorkoutService/UpdateWorkoutPlan',
      request,
      metadata || {},
      methodDescriptor_WorkoutService_UpdateWorkoutPlan);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.DeleteWorkoutPlanRequest,
 *   !proto.fitness.service.v1.DeleteWorkoutPlanResponse>}
 */
const methodDescriptor_WorkoutService_DeleteWorkoutPlan = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.WorkoutService/DeleteWorkoutPlan',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.DeleteWorkoutPlanRequest,
  proto.fitness.service.v1.DeleteWorkoutPlanResponse,
  /**
   * @param {!proto.fitness.service.v1.DeleteWorkoutPlanRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.DeleteWorkoutPlanResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.DeleteWorkoutPlanRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.DeleteWorkoutPlanResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.DeleteWorkoutPlanResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.WorkoutServiceClient.prototype.deleteWorkoutPlan =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.WorkoutService/DeleteWorkoutPlan',
      request,
      metadata || {},
      methodDescriptor_WorkoutService_DeleteWorkoutPlan,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.DeleteWorkoutPlanRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.DeleteWorkoutPlanResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.WorkoutServicePromiseClient.prototype.deleteWorkoutPlan =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.WorkoutService/DeleteWorkoutPlan',
      request,
      metadata || {},
      methodDescriptor_WorkoutService_DeleteWorkoutPlan);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.GetDailyWorkoutsRequest,
 *   !proto.fitness.service.v1.GetDailyWorkoutsResponse>}
 */
const methodDescriptor_WorkoutService_GetDailyWorkouts = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.WorkoutService/GetDailyWorkouts',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.GetDailyWorkoutsRequest,
  proto.fitness.service.v1.GetDailyWorkoutsResponse,
  /**
   * @param {!proto.fitness.service.v1.GetDailyWorkoutsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.GetDailyWorkoutsResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.GetDailyWorkoutsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.GetDailyWorkoutsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.GetDailyWorkoutsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.WorkoutServiceClient.prototype.getDailyWorkouts =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.WorkoutService/GetDailyWorkouts',
      request,
      metadata || {},
      methodDescriptor_WorkoutService_GetDailyWorkouts,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.GetDailyWorkoutsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.GetDailyWorkoutsResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.WorkoutServicePromiseClient.prototype.getDailyWorkouts =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.WorkoutService/GetDailyWorkouts',
      request,
      metadata || {},
      methodDescriptor_WorkoutService_GetDailyWorkouts);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.GetDailyWorkoutRequest,
 *   !proto.fitness.service.v1.GetDailyWorkoutResponse>}
 */
const methodDescriptor_WorkoutService_GetDailyWorkout = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.WorkoutService/GetDailyWorkout',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.GetDailyWorkoutRequest,
  proto.fitness.service.v1.GetDailyWorkoutResponse,
  /**
   * @param {!proto.fitness.service.v1.GetDailyWorkoutRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.GetDailyWorkoutResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.GetDailyWorkoutRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.GetDailyWorkoutResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.GetDailyWorkoutResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.WorkoutServiceClient.prototype.getDailyWorkout =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.WorkoutService/GetDailyWorkout',
      request,
      metadata || {},
      methodDescriptor_WorkoutService_GetDailyWorkout,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.GetDailyWorkoutRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.GetDailyWorkoutResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.WorkoutServicePromiseClient.prototype.getDailyWorkout =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.WorkoutService/GetDailyWorkout',
      request,
      metadata || {},
      methodDescriptor_WorkoutService_GetDailyWorkout);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.UpdateDailyWorkoutRequest,
 *   !proto.fitness.service.v1.UpdateDailyWorkoutResponse>}
 */
const methodDescriptor_WorkoutService_UpdateDailyWorkout = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.WorkoutService/UpdateDailyWorkout',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.UpdateDailyWorkoutRequest,
  proto.fitness.service.v1.UpdateDailyWorkoutResponse,
  /**
   * @param {!proto.fitness.service.v1.UpdateDailyWorkoutRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.UpdateDailyWorkoutResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.UpdateDailyWorkoutRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.UpdateDailyWorkoutResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.UpdateDailyWorkoutResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.WorkoutServiceClient.prototype.updateDailyWorkout =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.WorkoutService/UpdateDailyWorkout',
      request,
      metadata || {},
      methodDescriptor_WorkoutService_UpdateDailyWorkout,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.UpdateDailyWorkoutRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.UpdateDailyWorkoutResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.WorkoutServicePromiseClient.prototype.updateDailyWorkout =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.WorkoutService/UpdateDailyWorkout',
      request,
      metadata || {},
      methodDescriptor_WorkoutService_UpdateDailyWorkout);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.DeleteDailyWorkoutRequest,
 *   !proto.fitness.service.v1.DeleteDailyWorkoutResponse>}
 */
const methodDescriptor_WorkoutService_DeleteDailyWorkout = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.WorkoutService/DeleteDailyWorkout',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.DeleteDailyWorkoutRequest,
  proto.fitness.service.v1.DeleteDailyWorkoutResponse,
  /**
   * @param {!proto.fitness.service.v1.DeleteDailyWorkoutRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.DeleteDailyWorkoutResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.DeleteDailyWorkoutRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.DeleteDailyWorkoutResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.DeleteDailyWorkoutResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.WorkoutServiceClient.prototype.deleteDailyWorkout =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.WorkoutService/DeleteDailyWorkout',
      request,
      metadata || {},
      methodDescriptor_WorkoutService_DeleteDailyWorkout,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.DeleteDailyWorkoutRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.DeleteDailyWorkoutResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.WorkoutServicePromiseClient.prototype.deleteDailyWorkout =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.WorkoutService/DeleteDailyWorkout',
      request,
      metadata || {},
      methodDescriptor_WorkoutService_DeleteDailyWorkout);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.StartWorkoutSessionRequest,
 *   !proto.fitness.service.v1.StartWorkoutSessionResponse>}
 */
const methodDescriptor_WorkoutService_StartWorkoutSession = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.WorkoutService/StartWorkoutSession',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.StartWorkoutSessionRequest,
  proto.fitness.service.v1.StartWorkoutSessionResponse,
  /**
   * @param {!proto.fitness.service.v1.StartWorkoutSessionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.StartWorkoutSessionResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.StartWorkoutSessionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.StartWorkoutSessionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.StartWorkoutSessionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.WorkoutServiceClient.prototype.startWorkoutSession =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.WorkoutService/StartWorkoutSession',
      request,
      metadata || {},
      methodDescriptor_WorkoutService_StartWorkoutSession,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.StartWorkoutSessionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.StartWorkoutSessionResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.WorkoutServicePromiseClient.prototype.startWorkoutSession =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.WorkoutService/StartWorkoutSession',
      request,
      metadata || {},
      methodDescriptor_WorkoutService_StartWorkoutSession);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.UpdateWorkoutSessionRequest,
 *   !proto.fitness.service.v1.UpdateWorkoutSessionResponse>}
 */
const methodDescriptor_WorkoutService_UpdateWorkoutSession = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.WorkoutService/UpdateWorkoutSession',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.UpdateWorkoutSessionRequest,
  proto.fitness.service.v1.UpdateWorkoutSessionResponse,
  /**
   * @param {!proto.fitness.service.v1.UpdateWorkoutSessionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.UpdateWorkoutSessionResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.UpdateWorkoutSessionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.UpdateWorkoutSessionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.UpdateWorkoutSessionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.WorkoutServiceClient.prototype.updateWorkoutSession =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.WorkoutService/UpdateWorkoutSession',
      request,
      metadata || {},
      methodDescriptor_WorkoutService_UpdateWorkoutSession,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.UpdateWorkoutSessionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.UpdateWorkoutSessionResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.WorkoutServicePromiseClient.prototype.updateWorkoutSession =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.WorkoutService/UpdateWorkoutSession',
      request,
      metadata || {},
      methodDescriptor_WorkoutService_UpdateWorkoutSession);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.CompleteWorkoutSessionRequest,
 *   !proto.fitness.service.v1.CompleteWorkoutSessionResponse>}
 */
const methodDescriptor_WorkoutService_CompleteWorkoutSession = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.WorkoutService/CompleteWorkoutSession',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.CompleteWorkoutSessionRequest,
  proto.fitness.service.v1.CompleteWorkoutSessionResponse,
  /**
   * @param {!proto.fitness.service.v1.CompleteWorkoutSessionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.CompleteWorkoutSessionResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.CompleteWorkoutSessionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.CompleteWorkoutSessionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.CompleteWorkoutSessionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.WorkoutServiceClient.prototype.completeWorkoutSession =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.WorkoutService/CompleteWorkoutSession',
      request,
      metadata || {},
      methodDescriptor_WorkoutService_CompleteWorkoutSession,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.CompleteWorkoutSessionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.CompleteWorkoutSessionResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.WorkoutServicePromiseClient.prototype.completeWorkoutSession =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.WorkoutService/CompleteWorkoutSession',
      request,
      metadata || {},
      methodDescriptor_WorkoutService_CompleteWorkoutSession);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.GetWorkoutSessionsRequest,
 *   !proto.fitness.service.v1.GetWorkoutSessionsResponse>}
 */
const methodDescriptor_WorkoutService_GetWorkoutSessions = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.WorkoutService/GetWorkoutSessions',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.GetWorkoutSessionsRequest,
  proto.fitness.service.v1.GetWorkoutSessionsResponse,
  /**
   * @param {!proto.fitness.service.v1.GetWorkoutSessionsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.GetWorkoutSessionsResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.GetWorkoutSessionsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.GetWorkoutSessionsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.GetWorkoutSessionsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.WorkoutServiceClient.prototype.getWorkoutSessions =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.WorkoutService/GetWorkoutSessions',
      request,
      metadata || {},
      methodDescriptor_WorkoutService_GetWorkoutSessions,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.GetWorkoutSessionsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.GetWorkoutSessionsResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.WorkoutServicePromiseClient.prototype.getWorkoutSessions =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.WorkoutService/GetWorkoutSessions',
      request,
      metadata || {},
      methodDescriptor_WorkoutService_GetWorkoutSessions);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.GetWorkoutSessionRequest,
 *   !proto.fitness.service.v1.GetWorkoutSessionResponse>}
 */
const methodDescriptor_WorkoutService_GetWorkoutSession = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.WorkoutService/GetWorkoutSession',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.GetWorkoutSessionRequest,
  proto.fitness.service.v1.GetWorkoutSessionResponse,
  /**
   * @param {!proto.fitness.service.v1.GetWorkoutSessionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.GetWorkoutSessionResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.GetWorkoutSessionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.GetWorkoutSessionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.GetWorkoutSessionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.WorkoutServiceClient.prototype.getWorkoutSession =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.WorkoutService/GetWorkoutSession',
      request,
      metadata || {},
      methodDescriptor_WorkoutService_GetWorkoutSession,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.GetWorkoutSessionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.GetWorkoutSessionResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.WorkoutServicePromiseClient.prototype.getWorkoutSession =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.WorkoutService/GetWorkoutSession',
      request,
      metadata || {},
      methodDescriptor_WorkoutService_GetWorkoutSession);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.GetClientProgressRequest,
 *   !proto.fitness.service.v1.GetClientProgressResponse>}
 */
const methodDescriptor_WorkoutService_GetClientProgress = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.WorkoutService/GetClientProgress',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.GetClientProgressRequest,
  proto.fitness.service.v1.GetClientProgressResponse,
  /**
   * @param {!proto.fitness.service.v1.GetClientProgressRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.GetClientProgressResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.GetClientProgressRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.GetClientProgressResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.GetClientProgressResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.WorkoutServiceClient.prototype.getClientProgress =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.WorkoutService/GetClientProgress',
      request,
      metadata || {},
      methodDescriptor_WorkoutService_GetClientProgress,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.GetClientProgressRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.GetClientProgressResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.WorkoutServicePromiseClient.prototype.getClientProgress =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.WorkoutService/GetClientProgress',
      request,
      metadata || {},
      methodDescriptor_WorkoutService_GetClientProgress);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.GetGroupProgressRequest,
 *   !proto.fitness.service.v1.GetGroupProgressResponse>}
 */
const methodDescriptor_WorkoutService_GetGroupProgress = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.WorkoutService/GetGroupProgress',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.GetGroupProgressRequest,
  proto.fitness.service.v1.GetGroupProgressResponse,
  /**
   * @param {!proto.fitness.service.v1.GetGroupProgressRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.GetGroupProgressResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.GetGroupProgressRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.GetGroupProgressResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.GetGroupProgressResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.WorkoutServiceClient.prototype.getGroupProgress =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.WorkoutService/GetGroupProgress',
      request,
      metadata || {},
      methodDescriptor_WorkoutService_GetGroupProgress,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.GetGroupProgressRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.GetGroupProgressResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.WorkoutServicePromiseClient.prototype.getGroupProgress =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.WorkoutService/GetGroupProgress',
      request,
      metadata || {},
      methodDescriptor_WorkoutService_GetGroupProgress);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.GetRosterProgressRequest,
 *   !proto.fitness.service.v1.GetRosterProgressResponse>}
 */
const methodDescriptor_WorkoutService_GetRosterProgress = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.WorkoutService/GetRosterProgress',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.GetRosterProgressRequest,
  proto.fitness.service.v1.GetRosterProgressResponse,
  /**
   * @param {!proto.fitness.service.v1.GetRosterProgressRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.GetRosterProgressResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.GetRosterProgressRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.GetRosterProgressResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.GetRosterProgressResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.WorkoutServiceClient.prototype.getRosterProgress =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.WorkoutService/GetRosterProgress',
      request,
      metadata || {},
      methodDescriptor_WorkoutService_GetRosterProgress,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.GetRosterProgressRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.GetRosterProgressResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.WorkoutServicePromiseClient.prototype.getRosterProgress =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.WorkoutService/GetRosterProgress',
      request,
      metadata || {},
      methodDescriptor_WorkoutService_GetRosterProgress);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.GetWorkoutStatsRequest,
 *   !proto.fitness.service.v1.GetWorkoutStatsResponse>}
 */
const methodDescriptor_WorkoutService_GetWorkoutStats = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.WorkoutService/GetWorkoutStats',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.GetWorkoutStatsRequest,
  proto.fitness.service.v1.GetWorkoutStatsResponse,
  /**
   * @param {!proto.fitness.service.v1.GetWorkoutStatsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.GetWorkoutStatsResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.GetWorkoutStatsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.GetWorkoutStatsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.GetWorkoutStatsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.WorkoutServiceClient.prototype.getWorkoutStats =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.WorkoutService/GetWorkoutStats',
      request,
      metadata || {},
      methodDescriptor_WorkoutService_GetWorkoutStats,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.GetWorkoutStatsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.GetWorkoutStatsResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.WorkoutServicePromiseClient.prototype.getWorkoutStats =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.WorkoutService/GetWorkoutStats',
      request,
      metadata || {},
      methodDescriptor_WorkoutService_GetWorkoutStats);
};


module.exports = proto.fitness.service.v1;

